// 
import WebComponent from '../webComponents/WebComponent';
import {dispatchEvent} from "fg-frontend/src/lib/dom";

const fragments = {
  ALL: '[data-fragment="CheckboxSelect.all"]',
  STATE: '[data-fragment="CheckboxSelect.stateButton"]',
};

class CheckboxSelect extends WebComponent {
  constructor(props) {
    super(props);
    this.resetCheckboxSelect = this.resetCheckboxSelect.bind(this);
    this.handleStateButton = this.handleStateButton.bind(this);
  }

  didMount() {
    const {
      enableStateButton,
    } = this.props;

    this.checkboxAll = this.element.querySelector(fragments.ALL);
    this.checkboxItems = this.element.querySelectorAll('input:not(' + fragments.ALL + ')');
    this.stateButton = document.querySelector(fragments.STATE);

    if (this.checkboxAll) {
      this.checkboxAll.addEventListener('change', this.resetCheckboxSelect);
    }

    // disablovani/enablovani target komponenty dle poctu vybranych checkboxu
    if (enableStateButton) {
      if (this.checkboxItems) {
        this.checkboxItems.forEach(item => {
          item.addEventListener('change', this.handleStateButton);
        });
      }

      this.handleStateButton();
    }
  }

  handleStateButton() {
    let checkedItems = 0;
    this.checkboxItems.forEach(function(item) {
      if (item.checked) {
        checkedItems++;
      }
    });

    if (checkedItems > 0) {
      this.stateButton.removeAttribute('disabled');
    }
    else {
      this.stateButton.setAttribute('disabled', 'disabled');
    }
  }

  resetCheckboxSelect(e) {
    e.stopPropagation();
    if (e.target.checked) {
      this.checkboxItems.forEach(function (item) {
        item.checked = false;
      });
    }
    this.dispatchChangeEvent();
  }

}

export default CheckboxSelect;



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/CheckboxSelect.js